import React, { FC, PropsWithChildren } from 'react';

import ArrowSvg from '../../../assets/icons/journey-down-arrow.svg?react';
import { themes } from 'kb-shared';
import styled from 'styled-components';

const { colors } = themes;

export const StepDetail: FC<PropsWithChildren> = ({ children }) => {
  return (
    <DetailWrapper>
      <Arrow className="arrow" />
      {children}
    </DetailWrapper>
  );
};

const DetailWrapper = styled.div`
  background: white;
  padding: 48px 28px 28px 28px;
  color: ${colors.neutral.primaryNavy};
  cursor: default;
  position: relative;
  background: white;
`;

const Arrow = styled(ArrowSvg)`
  position: absolute;
  top: 0;
`;

const Subheader = styled.div`
  margin-bottom: 0;
  font-weight: bold;

  :first-of-type {
    margin: 0;
  }
`;

const Description = styled.p`
  margin: 0;
  margin-bottom: 28px;
`;

export { Description, Subheader };
